import React from 'react'
import './EVContactImage.css'

const EVContactImage: React.FC = () => {
  return (
    <div className="ev-contact-image">
      <img 
        src="/Kombi.svg" 
        alt="Luxury VW Kombi"
        className="ev-contact-img"
      />
    </div>
  )
}

export default EVContactImage
